import { Component, OnInit } from '@angular/core';
import { Constants } from '../../constants';
import { environment } from 'src/environments/environment';
import { FormControl } from '@angular/forms';
import { FGAData } from 'src/app/fga/models';
import { Subscription } from 'rxjs';
import { AetStateService } from 'src/app/services/aet-state.service';
// import { VersionCheckService } from 'src/app/service/cache.service';

@Component({
    selector: 'app-lios-navbar',
    templateUrl: './lios-navbar.component.html',
    styleUrls: ['./lios-navbar.component.scss'],
    standalone: false
})
export class LiosNavbarComponent implements OnInit {
	navlinks = this.constants.navLinkItems;
	rolesArray = [];
	fgaDetails: FGAData | null = null;
	private subscription: Subscription;
	highlightHome = false;
  selected = new FormControl();
  currentIndex: any = 0;
	constructor(private readonly constants: Constants, private readonly aetStateService: AetStateService) { }

	ngOnInit() {
		this.subscription = this.aetStateService.getDetails().subscribe(details => {
			this.fgaDetails = details;
			console.info('[Header] FGA details received:', details);
			if (this.fgaDetails) {
				let roles = []
				this.rolesArray = [];
				roles = this.fgaDetails?.roles
				if(roles?.length) {
					roles.forEach(e => {
						this.rolesArray.push(e.displayName)
					})
				}
			}
		});
		this.selected.setValue(1);
    	this.toggler('planning');
	}

	ngOnDestroy(): void { // NOSONAR
		this.subscription.unsubscribe();
	}
	
	onTabClick(index: any) { // NOSONAR
    localStorage.setItem('currentIndex', index.toString());
    }

	navigate(url: any) { // NOSONAR
		const _url = environment.LIOS_HOME_URL + url;
		console.log("_url_ ", _url)
		window.location.href = _url;
	}

	navigateExternalUrl(url: any) { // NOSONAR
		window.location.href = url;
	}

	navigateExternalUrlNewWin(url: any) { // NOSONAR
		window.open(url);
	}

	toggler(pageHeader: string): void { // NOSONAR
		if ( pageHeader.includes('home') || pageHeader == '' || pageHeader == '#' ) { // NOSONAR
			this.highlightHome = true;
		} else {
			this.highlightHome = false;
		}
	}
}